export const UPLOAD_STATUS = {
  canceled: "canceled",
  error: "error",
  paused: "paused",
  running: "running",
  success: "success",
  default: "default",
};

export interface File {
  id: string;
  name: string;
  fileName: string;
  lastModified: number;
  timestamp: number;
  status: string;
  error?: Error;
  fileData: any;
}
